/**
 * contact-form.js — Studio 1/1
 * ---------------------------------------------------------------------------
 * Contact page behavior:
 *   1. Inquiry category cards (contact-form.liquid) and the collaboration
 *      CTA (contact-collaboration.liquid) both use [data-category-trigger]
 *      — clicking one preselects the matching Subject option and scrolls
 *      to the form. No page navigation, no second form.
 *   2. Subject <select> change toggles the Order Number field — visible
 *      only when "Order Support" is selected.
 *   3. Shopify's native contact form re-populates contact[name]/[email]/
 *      [body] itself after a failed submission (form.name/form.email/
 *      form.body), but not custom fields like Subject/Order Number. This
 *      file saves those two to sessionStorage on every change and restores
 *      them when the form re-renders with data-restore-form="true" (set by
 *      Liquid when form.errors is present) — full "preserve entered
 *      information on validation failure" without a custom backend.
 *
 * Hooks consumed:
 *   [data-category-trigger]     any element with data-subject-value
 *   [data-subject-select]       the Subject <select>
 *   [data-order-number-field]   wrapper hidden unless Subject = "Order Support"
 *   [data-order-number-input]
 *   [data-restore-form]         "true" on the <form> after a failed submit
 */

(() => {
  'use strict';

  var STORAGE_KEY = 'studio1of1:contactFormDraft';
  var form = document.querySelector('#ContactForm');
  var subjectSelect = document.querySelector('[data-subject-select]');
  var orderField = document.querySelector('[data-order-number-field]');
  var orderInput = document.querySelector('[data-order-number-input]');

  function updateOrderFieldVisibility() {
    if (!subjectSelect || !orderField) return;
    orderField.hidden = subjectSelect.value !== 'Order Support';
  }

  function saveDraft() {
    if (!subjectSelect) return;
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
        subject: subjectSelect.value,
        orderNumber: orderInput ? orderInput.value : '',
      }));
    } catch (e) {}
  }

  function restoreDraft() {
    if (!form || form.dataset.restoreForm !== 'true') return;
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return;
      var draft = JSON.parse(raw);
      if (subjectSelect && draft.subject) subjectSelect.value = draft.subject;
      if (orderInput && draft.orderNumber) orderInput.value = draft.orderNumber;
      updateOrderFieldVisibility();
    } catch (e) {}
  }

  if (subjectSelect) {
    subjectSelect.addEventListener('change', function () {
      updateOrderFieldVisibility();
      saveDraft();
    });
  }
  if (orderInput) {
    orderInput.addEventListener('input', saveDraft);
  }

  restoreDraft();
  updateOrderFieldVisibility();

  document.querySelectorAll('[data-category-trigger]').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var value = trigger.dataset.subjectValue;
      var targetForm = document.querySelector('#contact-form');
      if (subjectSelect && value) {
        subjectSelect.value = value;
        subjectSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (targetForm) targetForm.scrollIntoView({ behavior: 'smooth', block: 'start' });
      var nameInput = document.querySelector('#ContactForm-name');
      if (nameInput) nameInput.focus({ preventScroll: true });
    });
  });
})();
